module.exports = __webpack_public_path__ + "static/media/server_error.725ff9ae.svg";